import React from 'react';
import './index.less';

interface FaeHeaderProps {
  // Define your props here
  title:string
  backClick?:()=>void
  rightSlot?:React.ReactNode
}

const prefix = 'fae-header';
const FaeHeader = (props:FaeHeaderProps) => {
  const {title='',backClick,rightSlot=<></>}=props;
  const handleBack=()=>{
    if(backClick){
      backClick();
    }
  }
  return (
    <div className={`${prefix}`}>
      {
        backClick&&<div className={`${prefix}-back`} onClick={handleBack}>
          <img src={require("@/assets/images/support/arrow-icon.png")} alt="" />
          返回上一页
        </div>
      }
       
        <div className={`${prefix}-title`}>
            <div className={`${prefix}-title-text`}>
              {title}
            </div>
            {rightSlot}
        </div>
    </div>
  );
};

export default React.memo(FaeHeader);
